import React, { useContext } from "react";
import { Box, Typography, Avatar, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TopCollectors from "../../Dashboard/Tops_score/TopCollectors";
import { BadgeListContext } from "../../../context/BadgeListContext";

const badgeQuantity = 3;

export default function StudentHomePanel({ user }) {
  const navigate = useNavigate();
  const { currentFavoriteBadges } = useContext(BadgeListContext);

  const badgeSlots = Array.from({ length: badgeQuantity }, (_, i) => {
    return currentFavoriteBadges?.[i] || null;
  });

  return (
    <div className="home-dashboard">
      <div className="home-welcome-block">
        <h3>Bienvenue {user?.first_name || "Étudiant"}</h3>
      </div>

      <div className="home-dashboard-grid">
        <div className="home-dashboard-card">
          <h4>Mes badges épinglés</h4>

          <Box
            sx={{
              mt: 2,
              display: "flex",
              gap: 3,
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {badgeSlots.map((badge, index) => (
              <Box
                key={index}
                sx={{
                  width: 110,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  gap: 1,
                }}
              >
                {badge ? (
                  <>
                    <Avatar
                      alt={badge.title}
                      src={badge.imagePath}
                      sx={{ width: 72, height: 72 }}
                    />
                    <Typography variant="body2">{badge.title}</Typography>
                  </>
                ) : (
                  <>
                    <Box
                      sx={{
                        width: 72,
                        height: 72,
                        borderRadius: "50%",
                        backgroundColor: "#e0e0e0",
                      }}
                    />
                    <Typography variant="body2" color="text.secondary">
                      Aucun badge
                    </Typography>
                  </>
                )}
              </Box>
            ))}
          </Box>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => navigate("/profile")}
            >
              Voir mon profil
            </Button>
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Classement</h4>

          <Box sx={{ mt: 2 }}>
            <TopCollectors />
          </Box>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => navigate("/leaderboard")}
            >
              Voir le classement complet
            </Button>
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Badges</h4>

          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => navigate("/badges")}
            >
              Voir tous les badges
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}